import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledFormsTemplateReadOnlyInsertLink = styled(Link)`
   font-weight: normal;
`;
StyledFormsTemplateReadOnlyInsertLink.displayName = 'StyledFormsTemplateReadOnlyInsertLink';
